import { defineStore } from 'pinia'   
import { computed, ref } from 'vue'
export interface IResolution {
    width: number,
    height: number
}

/** store of localized units of measurement */
export const useBrowserStateStore = defineStore('browserStateStore', () => {
    /********************************************************************************************************************
     STATE
     ********************************************************************************************************************/
    const smallScreenWidth = 500
    let _initialized = false
    const _resolution = ref<IResolution | null>(null)

    /********************************************************************************************************************
     GETTERS
    ********************************************************************************************************************/
    /** current resolution */
    const resolution = computed(() => _resolution.value);

    const isSmallScreen = computed(() => _resolution.value
        ? _resolution.value.width <= smallScreenWidth
        : false
    )

    const getters = { resolution, isSmallScreen }       

    /********************************************************************************************************************
     ACTIONS
     ********************************************************************************************************************/
    // REMOVED: This does NOT work, as it does not take into account, that a scrollbar can appear/disappear dynamically
    //          "ResizeObserver" solved this (see below)
    //function widthOfElement(element: HTMLElement | null): number | null {
    //    // note that the dependency on _resolution ensures that this will behave reactively, whenever the resolution changes!
    //    const result = _resolution.value != null && element != null
    //        ? element.clientWidth
    //        : null

    //    return result
    //}

    function elementObserverFor(element: HTMLElement | null, action: (element: Element) => void): ResizeObserver | null {
        if (element == null) return null

        const observer = new ResizeObserver((entries) => {
            action(entries[0].target)
        })

        observer.observe(element)
        return observer
    }

    const actions = { elementObserverFor }

    /********************************************************************************************************************
     PRIVATE EVENT HANDLER
     ********************************************************************************************************************/
    function handleResize() {
        _resolution.value = {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }

    /********************************************************************************************************************
     INITIALIZATION
     ********************************************************************************************************************/
    if (!_initialized) {
        _initialized = true
        window.addEventListener('resize', handleResize)
        handleResize() // initialization
    }

    return { _resolution, ...getters, ...actions }
})